enum ToastStatus {
    SUCCESS = 'success',
    ERROR = 'error',
    LOADING = 'loading',
    INFO = 'info',
}

export { ToastStatus }
